<template>
  <div
    class="calls-section"
    :class="isContrast != 'false' && isContrast != false ? 'high-contrast' : ''"
  >
    <DxTabPanel
      width="100%"
      :animation-enabled="false"
      :hover-state-enabled="false"
      :swipe-enabled="true"
      item-template="tabPanel"
      tabs-position="left"
      styling-mode="secondary"
      :items="timeScopeOptions"
      v-model:selected-index="selectedTabIndex"
      :no-data-text="t('scheme_details.no_open_openings_or_current_deadlines')"
      :item-title-template="getTabTitle"
      class="calls-tab-panel"
    >
      <template #tabPanel>
        <CallsCardView
          @items-loaded="$emit('items-loaded', $event)"
          :selectedTabIndex="selectedTabIndex"
          :parentSchemeId="parentSchemeId"
        />
      </template>
    </DxTabPanel>
  </div>
</template>

<script>
import { ref, computed, inject, onMounted, provide } from "vue";
import store from "../store/index";
import GrantsService from "../services/grants.service";
import { useI18n } from "vue-i18n";
import { DxTabPanel } from "devextreme-vue/tab-panel";
import CallsCardView from "./CallsCardView.vue";
import ETimeScope from "../enums/ETimeScope";

export default {
  name: "Calls",
  components: {
    CallsCardView,
    DxTabPanel,
  },
  props: {
    schemeId: Number,
    countOfActiveOpenings: Number,
    countOfPastOpenings: Number,
    countOfFutureOpenings: Number,
  },
  setup(props) {
    const { t } = useI18n();
    const isVind = inject("isVind");
    const selectedTabIndex = ref(0);
    const timeScopeOptions = computed(
      () => store.state.grantItems.timeScopeOptions
    );
    const activeOpeningsCount = ref(props.countOfActiveOpenings);
    const pastOpeningsCount = ref(props.countOfPastOpenings);
    const futureOpeningsCount = ref(props.countOfFutureOpenings);
    const parentSchemeId = ref(props.schemeId);

    provide("isVind", isVind);

    onMounted(async () => {
      GrantsService.getCallTimeScopes();
    });

    const getTabTitle = (item) => {
      let title = item.description;

      if (item.id == ETimeScope.Active)
        title += " (" + activeOpeningsCount.value + ")";
      else if (item.id == ETimeScope.Past)
        title += " (" + pastOpeningsCount.value + ")";
      else if (item.id == ETimeScope.Future)
        title += " (" + futureOpeningsCount.value + ")";

      return title;
    };

    const isContrast = computed({
      get: () => store.state.user.isSelectedThemeContrast,
    });

    return {
      t,
      isContrast,
      isVind,
      timeScopeOptions,
      activeOpeningsCount,
      futureOpeningsCount,
      pastOpeningsCount,
      parentSchemeId,
      selectedTabIndex,
      getTabTitle,
    };
  },
};
</script>
